import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_STUDENT_DOCUMENT_FIELDS } from '@/graphql/studentDocumentFields';
import type { StudentDocumentFieldListQuery } from '@/types/operations';

/**
 * Built-in profile fields (beyond name and matric no.) and the school's
 * active student custom fields that documents can print (#574).
 */
export function useStudentDocumentFields() {
  const { result, loading, error, refetch } = useQuery<StudentDocumentFieldListQuery>(
    GET_STUDENT_DOCUMENT_FIELDS,
    null,
    { fetchPolicy: 'cache-and-network' },
  );

  return {
    fields: computed(() => result.value?.studentDocumentFields ?? []),
    loading,
    error,
    refetch,
  };
}
